import { MouseEvent } from 'react';
import { useTheme } from 'styled-components';

interface FavoriteIconProps {
  dataTestId?: string;
  selected?: boolean;
  onClick?: (event: MouseEvent) => void;
}

export const FavoriteIcon: React.FC<FavoriteIconProps> = ({ selected, onClick, dataTestId }) => {
  const theme = useTheme();
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      data-testid={dataTestId}
    >
      <path
        d="M8 12.216L12.944 15.2L11.632 9.576L16 5.792L10.248 5.304L8 0L5.752 5.304L0 5.792L4.368 9.576L3.056 15.2L8 12.216Z"
        fill={selected ? '#FFD952' : 'transparent'}
        stroke={selected ? '#FFD952' : theme.secondary.softBlue1}
      />
    </svg>
  );
};
